import { useEffect } from "react";

interface TestProps {}

export const Test = (props: TestProps) => {
  async function handleClick(): Promise<void> {}

  return (
    <div style={{ textAlign: "center" }}>
      <button onClick={handleClick}>Press</button>
    </div>
  );
};
